import { DOWNLOAD_FILE_REQUEST, downloadFileFailure, downloadFileSuccess} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function downloadFileEpic(action$, store$, { FileRepository }) {
    return action$.pipe(
        ofType(DOWNLOAD_FILE_REQUEST),
        mergeMap( action =>{
            const { guid } = action.payload;

            if(!guid.trim()) {
                return EMPTY;
            }

            return from(
                FileRepository.downloadByGuid( guid )
                    .then(file => downloadFileSuccess(file))
                    .catch(error => downloadFileFailure(error)),
            );
        }),
    );
}
